import { VueSlideToggle } from "vue-slide-toggle";
import { mapGetters, mapMutations } from "vuex";

export default {
    name: "CosmoBasePlans",
    props: {},
    emits: [],
    components: { VueSlideToggle },
    setup() {},
    data() {
        return {
          openedCollapse: [],
          webinarInBasket: [],
        }
    },
    created() {},
    mounted() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    watch: {
      basket: function () {
        this.basket.forEach(product => {
          this.webinarInBasket.push(product.id);
        });
      },
    },
    computed: {
      ...mapGetters({
        content: "cosmobase/content",
        menu: "setting/headerMenu",
        basket: "basket/basket",
        page: "pages/page",
        isAuthenticated: "auth/isAuthenticated",
        isDistributor: "profile/isDistributor",
        isProfessional: "profile/isProfessional",
        isPatient: "profile/isPatient",
        isUserWithCode: "profile/isUserWithCode",
      }),
    },
    methods: {
      ...mapMutations({
        changeCosmoBaseFormPopup: "popups/CHANGE_COSMOBASE_FORM_POPUP",
        addWebinarToBasket: "basket/ADD_WEBINAR_ITEM_TO_BASKET",
        changeBasketPopup: "basket/SHOW_BASKET_POPUP",
        changeSeminarInfo: "popups/SHOW_SEMINAR_INFO_POPUP",
        setSeminarInfoContent: "popups/SET_SEMINAR_INFO_CONTENT",
        showSeminarProfessionalOnlyPopup: "popups/SHOW_SEMINAR_PROFESSIONAL_ONLY_POPUP",
      }),
      showSeminarInfoPopup(title, description) {
        this.changeSeminarInfo(true);
        this.setSeminarInfoContent({ title: title, description: description });
      },
      checkCoursesInBasket(id) {
        this.webinarInBasket.push(id);
      },
      InBasket(id) {
        return this.basket.find(product => product.id === id);
      },
      handleWebinarToBasket(product) {
        if (!(this.isProfessional || this.isPatient || this.isUserWithCode)) {
          this.showSeminarProfessionalOnlyPopup(true);
          return;
        }
        console.log(product.productPrices.data[0]);

        this.addWebinarToBasket({
          select_count: 1,
          product,
          product_price: product.productPrices.data[0],
        });
        this.changeBasketPopup(true);
        this.checkCoursesInBasket(product.id);
        this.$toasted.success("Успішно додано в кошик");
      },
      /**
       * @param {number} price
       * @returns {string}
       */
      formatPrice(price) {
        return price.toLocaleString('fr-FR', {});
      },
      scrollToCosmobaseForm() {
        const anchor = document.querySelector(".cosmobase__form .cosmobase__form--title");
        this.$smoothScroll({
          scrollTo: anchor,
          duration: 1000,
        });
      },
      openCosmoBaseForm() {
        this.changeCosmoBaseFormPopup(true);
      },
      isCollapseOpen(index) {
        return this.openedCollapse.includes(index)
      },
      toggleCollapse(index) {
        const arrayIndex = this.openedCollapse.indexOf(index);
        if (arrayIndex !== -1) {
          this.openedCollapse.splice(arrayIndex, 1);
        } else {
          this.openedCollapse.push(index);
        }
      }
    }
}
